import { render, staticRenderFns } from "./PlgCampaigns.vue?vue&type=template&id=38c4b4a1&"
import script from "./PlgCampaigns.vue?vue&type=script&lang=js&"
export * from "./PlgCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./PlgCampaigns.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38c4b4a1')) {
      api.createRecord('38c4b4a1', component.options)
    } else {
      api.reload('38c4b4a1', component.options)
    }
    module.hot.accept("./PlgCampaigns.vue?vue&type=template&id=38c4b4a1&", function () {
      api.rerender('38c4b4a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/PlgCampaigns.vue"
export default component.exports